import React, { useState, useRef } from "react";
import "./ImageMerger.scss";
import close from "./assets/close.png";

const ImageMerger = () => {
  const [images, setImages] = useState({ image1: null, image2: null });
  const [mergedImage, setMergedImage] = useState(null);
  const canvasRef = useRef(null);
  const fileInputRefs = {
    image1: useRef(null),
    image2: useRef(null),
  };

  const handleButtonClick = (imageKey) => {
    if (fileInputRefs[imageKey].current) {
      fileInputRefs[imageKey].current.click();
    }
  };

  const handleImageChange = (e, imageKey) => {
    setImages({
      ...images,
      [imageKey]: URL.createObjectURL(e.target.files[0]),
    });
  };

  const resizeImage = (image, width, height) => {
    return new Promise((resolve) => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      const img = new Image();
      img.onload = () => {
        const scale = Math.min(width / img.width, height / img.height);
        const newWidth = img.width * scale;
        const newHeight = img.height * scale;
        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(
          img,
          (width - newWidth) / 2,
          (height - newHeight) / 2,
          newWidth,
          newHeight
        );
        resolve(canvas.toDataURL("image/png"));
      };
      img.src = image;
    });
  };

  const mergeImages = async () => {
    const { image1, image2 } = images;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const width = 360;
    const height = 360;

    const resizedImage1 = await resizeImage(image1, width, height);
    const resizedImage2 = await resizeImage(image2, width, height);

    const img1 = new Image();
    const img2 = new Image();
    img1.src = resizedImage1;
    img2.src = resizedImage2;

    img1.onload = () => {
      canvas.width = width;
      canvas.height = height * 2;
      ctx.drawImage(img1, 0, 0);
      img2.onload = () => {
        ctx.drawImage(img2, 0, height);
        setMergedImage(canvas.toDataURL("image/png"));
      };
    };
  };

  const handleDownloadClick = () => {
    if (mergedImage) {
      const link = document.createElement("a");
      link.href = mergedImage;
      link.download = "merged_image.png";
      link.click();
      setImages((prevImages) => ({
        ...prevImages,
        image2: null,
      }));
      setMergedImage(null);
    }
  };

  const deleteImage = (imageKey) => {
    setImages({ ...images, [imageKey]: null });
    setMergedImage(null);
  };

  const canMerge = images.image1 && images.image2;

  return (
    <div className="marge_image_main">
      <h2>Merge Two Images</h2>
      <div className="marge_image_wrap">
        <div className="image_main_wrap">
          {["image1", "image2"].map((imageKey) => (
            <div key={imageKey} className="image_label_main">
              <label htmlFor="">
                {imageKey === "image1" ? "Water Mark Image" : "ProductImage"}
              </label>
              <div className="marge_image">
                {!images[imageKey] && (
                  <>
                    <div
                      className="choose_file_main"
                      onClick={() => handleButtonClick(imageKey)}
                    >
                      <button>Choose File</button>
                      <input
                        type="file"
                        accept="image/*"
                        ref={fileInputRefs[imageKey]}
                        style={{ display: "none" }}
                        onChange={(e) => handleImageChange(e, imageKey)}
                      />
                    </div>
                  </>
                )}
                {images[imageKey] && (
                  <div className="image_main">
                    <img src={images[imageKey]} alt={`Image ${imageKey}`} />
                    <div
                      className="close_icon"
                      onClick={() => deleteImage(imageKey)}
                    >
                      <img src={close} alt="close" />
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
        {canMerge && (
          <button onClick={mergeImages} className="btn_main">
            Merge Image
          </button>
        )}
        {mergedImage && (
          <div className="merged_image_wrap">
            <div className="merged_image_main">
              <img src={mergedImage} alt="Merged" className="merged_image" />
            </div>
            <button onClick={handleDownloadClick} className="btn_main">
              Download Merged Image
            </button>
          </div>
        )}
      </div>
      <canvas ref={canvasRef} style={{ display: "none" }}></canvas>
    </div>
  );
};

export default ImageMerger;
